import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Wrench } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/fleet-maintenance`;

// Dashboard flag for fleet managers: overdue / due-soon maintenance items.
export default function FleetAlertsCard() {
  const [data, setData] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    axios.get(`${API}/alerts`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then(r => setData(r.data)).catch(() => setData(null));
  }, []);
  if (!data || (data.alerts || []).length === 0) return null;
  const hasOverdue = data.overdue > 0;
  return (
    <div data-testid="fleet-alerts-card"
      className={`rounded-xl border bg-white p-4 flex flex-col sm:flex-row sm:items-center gap-3 shadow-sm border-l-4 ${hasOverdue ? 'border-red-200 border-l-red-600' : 'border-amber-200 border-l-amber-500'}`}>
      <Wrench className={`w-6 h-6 shrink-0 ${hasOverdue ? 'text-red-600' : 'text-amber-600'}`} />
      <div className="flex-1 min-w-0">
        <p className={`font-bold text-sm ${hasOverdue ? 'text-red-950' : 'text-amber-950'}`} data-testid="fleet-alerts-title">
          Fleet maintenance: {data.overdue} overdue · {data.due_soon} due soon
        </p>
        <p className="text-xs text-slate-600 truncate">
          {data.alerts.slice(0, 3).map(a => `${a.equipment_name} — ${a.label} (${a.summary})`).join(' · ')}
          {data.alerts.length > 3 ? ` · +${data.alerts.length - 3} more` : ''}
        </p>
      </div>
      <button onClick={() => navigate('/fleet-maintenance')} data-testid="fleet-alerts-open"
        className={`shrink-0 px-4 py-2 rounded-lg text-xs font-bold transition-colors shadow-sm ${hasOverdue ? 'text-white bg-red-600 hover:bg-red-500' : 'text-slate-950 bg-amber-500 hover:bg-amber-400'}`}>
        Open Fleet Maintenance
      </button>
    </div>
  );
}
